<template>
  <content-page :loading="isLoading"
                :title="$t('details.title')"
                :class="$setClasses">
    <div v-if="demand"
         :class="$vClass('body')">
      <el-card v-if="isMinarm"
               :class="$vClass('body__minarm')">
        <component :is="minarmRightsLoader" />
      </el-card>
      <el-card v-if="selectedOffer && selectedOffer.mover"
               :class="$vClass('mover')">
          <div :class="$vClass('mover__content')">
            <mover-description :mover="selectedOffer.mover"
                              class="no-padding"
                              display-rates
                              hide-no-rating/>
            <component :is="actionsLoader"
                      :offer="selectedOffer"
                      class="offer__actions">
            </component>
          </div>
      </el-card>
      <quote :offer="selectedOffer"
             :is-box="false"
             class="u-margin-top-default"></quote>
    </div>
  </content-page>
</template>

<script>
import { mapGetters } from 'vuex';
import ConfigLoader from '@/utils/components/ConfigLoader.vue';
import ContentPage from '@/components/layout/ContentPage.vue';
import Quote from '@/utils/components/Quote.vue';
import MoverDescription from '@/components/offer/fragments/MoverDescription.vue';

export default {
  name: 'detailsDemand',
  nameClassStyle: 'details',
  extends: ConfigLoader,
  components: {
    ContentPage,
    Quote,
    MoverDescription,
  },
  computed: {
    ...mapGetters({
      projectSelected: 'projectStore/projectSelected',
      demand: 'demandStore/demand',
      selectedOffer: 'configStore/offer',
    }),
    minarmRightsLoader() {
      return () => import('@/components/details/MinarmRights.vue');
    },
    actionsLoader() {
      const path = 'components/comparator/offers/offer/';
      const component = this.projectSelected.params.is_commissionaire
        ? 'SpecialActions'
        : 'DefaultActions';
      return () => import(`@/${path}${component}.vue`);
    },
  },
};
</script>

<style scoped lang="scss">
.details {
  &__mover__content {
    display: flex;
    flex-direction: column;

    :deep(& > div:last-child) {
      margin-top: 20px;
      @include breakpoint(tablet) {
        flex-direction: row;
      }
      gap: 10px;

      a, button {
        margin: 0;
        flex: 1;
      }
    }
  }

  &__body {
    border-radius: 0;
    position: relative;

    &__minarm {
      border-radius: 0;
      margin-bottom: 20px;
      @include breakpoint(tablet) {
        border-radius: 4px;
      }
    }

    :deep(.quote__wrapper__mover) {
      border-top: 1px solid $--color-grey;

      .card-flex__content {
        width: 100%;

        .mover-description__mover__info {
          align-items: flex-start;

          &__name {
            text-align: start;
          }
        }
      }
      h3 {
        margin-top: 10px !important;
        font-size: var(--nxt-font-size-large);
        padding-left: var(--nxt-space-default);
      }
    }
  }
}

:deep(.table__item__icon) {
  &.fa-times-circle, &.fa-circle-xmark {
    color: $--color-danger;
  }
}
</style>
